import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f1969e63911b00143d0635_1785013712057_e7b30381/dispatch_1777440414708/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download_production/69f1969e63911b00143d0635_1785013712057_e7b30381/dispatch_1777440414708/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f1969e63911b00143d0635_1785013712057_e7b30381/dispatch_1777440414708/src/styles/tailwind.css");
